// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"50812a89","87":"0832a937","94":"9af8b935","299":"10e6f302","787":"9e7a4f43","803":"5bbd4ae9","887":"661273c4","907":"06f20bb9"}[chunkId] + ".chunk.js";
};